// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Transitions for flipping a page back and fourth when two pages visibel */
.left-page-enter:not(.turned),
.right-page-reverse-enter:not(.turned) {
  transition: transform 0.15s 0.15s ease-out !important; 
  transform: scaleX(0) !important;
}
.left-page-enter.left-page-enter-active:not(.turned),
.right-page-reverse-enter.right-page-reverse-enter-active:not(.turned) {
  transform: scaleX(1) !important;
}

.right-page-leave,
.left-page-reverse-leave {
  transition: transform 0.15s ease-in !important; 
}
.right-page-leave.right-page-leave-active,
.left-page-reverse-leave.left-page-reverse-leave-active {
  transform: scaleX(0) !important;
}

/* Transitions for throwing pages on and off the stach when one page visible */
.one-page-leave.one-page-leave-active,
.one-page-reverse-enter,
.one-page-leave:not(.turned),
.one-page-reverse-enter.one-page-reverse-enter-active:not(.turned) {
  transform: translateX(calc(-100% - 50vw)) scale(1.1) !important;
  opacity: 0;
}

/* Toolbar and searchbar show and hide animations */
.toolbox-enter, .searchbar-enter,
.toolbox-leave-active, .searchbar-leave-active {
  opacity: 0;
  transition: opacity 0.3s ease;
}
.toolbox-leave, .searchbar-leave,
.toolbox-enter-active, .searchbar-enter-active {
  opacity: 1;
  transition: opacity 0.3s ease;
}
`, "",{"version":3,"sources":["webpack://./assets/css/transitions.css"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E;;EAEE,qDAAqD;EACrD,+BAA+B;AACjC;AACA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,8CAA8C;AAChD;AACA;;EAEE,+BAA+B;AACjC;;AAEA,8EAA8E;AAC9E;;;;EAIE,+DAA+D;EAC/D,UAAU;AACZ;;AAEA,mDAAmD;AACnD;;EAEE,UAAU;EACV,6BAA6B;AAC/B;AACA;;EAEE,UAAU;EACV,6BAA6B;AAC/B","sourcesContent":["/* Transitions for flipping a page back and fourth when two pages visibel */\n.left-page-enter:not(.turned),\n.right-page-reverse-enter:not(.turned) {\n  transition: transform 0.15s 0.15s ease-out !important; \n  transform: scaleX(0) !important;\n}\n.left-page-enter.left-page-enter-active:not(.turned),\n.right-page-reverse-enter.right-page-reverse-enter-active:not(.turned) {\n  transform: scaleX(1) !important;\n}\n\n.right-page-leave,\n.left-page-reverse-leave {\n  transition: transform 0.15s ease-in !important; \n}\n.right-page-leave.right-page-leave-active,\n.left-page-reverse-leave.left-page-reverse-leave-active {\n  transform: scaleX(0) !important;\n}\n\n/* Transitions for throwing pages on and off the stach when one page visible */\n.one-page-leave.one-page-leave-active,\n.one-page-reverse-enter,\n.one-page-leave:not(.turned),\n.one-page-reverse-enter.one-page-reverse-enter-active:not(.turned) {\n  transform: translateX(calc(-100% - 50vw)) scale(1.1) !important;\n  opacity: 0;\n}\n\n/* Toolbar and searchbar show and hide animations */\n.toolbox-enter, .searchbar-enter,\n.toolbox-leave-active, .searchbar-leave-active {\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n.toolbox-leave, .searchbar-leave,\n.toolbox-enter-active, .searchbar-enter-active {\n  opacity: 1;\n  transition: opacity 0.3s ease;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
